import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	title: {
		id: 'invite-prompt-on-page-publish.invite-prompt-flag.title',
		defaultMessage: 'You and {displayName} worked together in Jira',
		description: 'Title of a flag that pops up after user first publishes a page',
	},
	description: {
		id: 'invite-prompt-on-page-publish.invite-prompt-flag.description',
		defaultMessage:
			'{displayName} could also use Confluence to capture and share team knowledge from one place.',
		description: 'Description of a flag pop up where the user can invite their top collaborator.',
	},
	addToConfluenceButton: {
		id: 'invite-prompt-on-page-publish.invite-prompt-flag.add-to-confluence-button',
		defaultMessage: 'Add to Confluence',
		description: 'CTA on a primary button to invite top collaborator',
	},
	dismiss: {
		id: 'invite-prompt-on-page-publish.invite-prompt-flag.dont-show-again',
		defaultMessage: `Don't show again`,
		description: 'Secondary button to dismiss the flag',
	},
});
